var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRCoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 75.78 75.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: #b7582f;\n        font-family: 'Roboto', sans-serif !important;\n        font-size: 25px;\n        font-weight: 800 !important;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 42.84,
    y1: 79.16,
    x2: 34.41,
    y2: 8.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e09255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4c256"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 37.89,
    y1: 5.82,
    x2: 37.89,
    y2: 68.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f29e5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7582f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 37.89,
    y1: 5.82,
    x2: 37.89,
    y2: 68.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 40.91,
    y1: 63.08,
    x2: 35.77,
    y2: 20.16,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 37.89,
    cy: 37.89,
    r: 37.89
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.89,58.06c-14.87,0-27.21-10.85-29.54-25.06-.26,1.59-.4,3.22-.4,4.89,0,16.54,13.41,29.95,29.95,29.95s29.95-13.41,29.95-29.95c0-1.67-.14-3.3-.4-4.89-2.33,14.21-14.67,25.06-29.54,25.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.89,58.06c14.87,0,27.21-10.85,29.54-25.06-2.33-14.21-14.67-25.06-29.54-25.06s-27.21,10.85-29.54,25.06c2.33,14.21,14.67,25.06,29.54,25.06Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 37.89,
    cy: 37.89,
    r: 23.13
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(29.55 46.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRCoin);
export default __webpack_public_path__ + "static/media/R_COIN.c0eb3ee6eb1fd7abbe05f0f688b4d5eb.svg";
export { ForwardRef as ReactComponent };